var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"appLogo"},[_c('div',{staticClass:"appLogo-icon"},[_c('AppIcon',{attrs:{"name":"logoIcon"}})],1),_c('div',{staticClass:"appLogo-typo"},[_c('AppIcon',{attrs:{"name":"logoAccounts"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }